  // src/context/AuthContext.tsx
  import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import UserApi from '../api-services/user-api.service';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import CustomerApi from '../api-services/customer-api.service';
import { SIGNIN_URL } from '../utils/helpers';

interface LoginFormValues {
  email?: string;
  password?: string;
}

interface AuthContextType {
  username: string | null;
  login: (userData: LoginFormValues) => void;
  logout: () => void;
  updateUsername: (username) => void;
  clearUser: () => void;
}

  const AuthContext = createContext<AuthContextType | undefined>(undefined);

  export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [username, setUsername] = useState("");
    const navigate = useNavigate();

    // Example: Load user from local storage on initial render
    useEffect(() => {
      const storedUser = localStorage.getItem('currentUser');
      if (storedUser) {
        setUsername(JSON.parse(storedUser));
      }
    }, []);

    const login = (userData: LoginFormValues) => {
      CustomerApi.login(userData)
        .then(username => {
          if(username){
            updateUsername(username);
            navigate('/web');
            navigate(0); //to remove if partner sign in page returns user data
          }
        })
        .catch(error => {
          notification.error({ message: error.response.data.error});
        });
    };

    const logout = () => {
      CustomerApi.logout()
        .then(success => {
          if(success){
            clearUser();
          }
        })
        .catch(error => {
          notification.error({ message: 'An error occured while signing out.'});
        });
    };

    const updateUsername = (newUsername: string) =>{
      setUsername(newUsername);
      localStorage.setItem('currentUser', JSON.stringify(newUsername)); // Store user data
    }

    const clearUser = () => {
      setUsername("");
      localStorage.clear();
      navigate(SIGNIN_URL);
      navigate(0);
    }

    return (
      <AuthContext.Provider value={{ username, login, logout, updateUsername, clearUser }}>
        {children}
      </AuthContext.Provider>
    );
  };

  export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
      throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
  };